import React, { useContext } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import "../../../css/login/login.css";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto


const AcountSuccessful = ({ LoginRequest, ReturnLogin, correo, loading }) => {
  const { language } = useContext(UtilContext); // Usa el contexto de Auth
  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-full md:w-3/4"
    >
      <div className="flex flex-col">
        <p className="text-3xl mb-4" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].acount_successful.title}
        </p>
        <p className="text-[#B7B7B9] text-[14px]">
          {GLOBAL_LANGUAGE[language].acount_successful.description1}{correo} {GLOBAL_LANGUAGE[language].acount_successful.description2}
        </p>

        <div className="flex flex-row justify-between mt-20 ">
          {/*  <p
            className="text-sm cursor-pointer"
            style={{ borderBottomWidth: 2 }}
          >
            Reenviar correo
          </p>
          <p
            className="text-sm cursor-pointer"
            style={{ borderBottomWidth: 2 }}
          >
            <a href="https://www.colurs.io/terminos/" target="_blank">
              Contactar a Soporte
            </a>
          </p> */}
          {/* 
          <ButtonBack onClick={ReturnLogin} label={"Volver al login"} />
          <ButtonWhite loading={loading} onClick={LoginRequest} label={"Seguir"} /> */}

        </div>
      </div>
    </div>
  );
};

export default AcountSuccessful;
